import {useEffect} from 'react'
import {BatchCompleted} from '../../../../../interfaces/batch'
import {
  useDownloadBatchMutation,
  useGetCompletedBatchesQuery,
} from '../../../../../redux/api/services/batch'
import {BatchCard} from '../../../../../helpers/elements/card/batch-card/BatchCard'
import {Link} from 'react-router-dom'
import {formatDate, getLink} from '../../../../../helpers/utilities'
import InfiniteScroll from 'react-infinite-scroll-component'
import {KTSVG} from '../../../../../template/_metronic/helpers'
import {ListLoading} from '../../../../../helpers/elements/table/loading/ListLoading'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {setCompletedBatchFilter} from '../../../../../redux/slices/completedBatchFilterSlice'
import {CustomErrorAlert} from '../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

const HistoryListCard = () => {
  const [downloadBatch, {data: batchFile}] = useDownloadBatchMutation()
  const currentCompletedBatchFilter = useSelector(
    (state: RootState) => state.completedBatchFilterSlice
  )
  const infoState = useSelector((state: RootState) => state.info)
  const dispatch = useDispatch()

  const completedBatchStatus = useGetCompletedBatchesQuery({
    info: infoState,
    requestContent: {
      filter: {
        searchTerm: currentCompletedBatchFilter.searchTerm,
        startDate: formatDate(new Date(currentCompletedBatchFilter.startDate || '')),
        endDate: formatDate(new Date(currentCompletedBatchFilter.endDate || '')),
      },
      clientTimezone: 'America/Guatemala',
      page: currentCompletedBatchFilter.page,
      pageSize: 10,
    },
  })

  useEffect(() => {
    if (!batchFile) return

    const url = getLink(batchFile.file)
    if (!url) return

    const a = document.createElement('a')
    a.href = url
    a.download = batchFile.filename
    a.click()
  }, [batchFile])

  useEffect(() => {
    if (currentCompletedBatchFilter.timestamp === '' && currentCompletedBatchFilter.page !== 1)
      return
    completedBatchStatus.refetch()
  }, [currentCompletedBatchFilter.timestamp])

  return (
    <>
      <CustomErrorAlert show={completedBatchStatus.isError} error={completedBatchStatus.error} />

      {completedBatchStatus.isFetching && <ListLoading />}

      {completedBatchStatus.data?.responseContent &&
      completedBatchStatus.data?.responseContent.length > 0 ? (
        <InfiniteScroll
          dataLength={completedBatchStatus.data?.responseContent.length || 0}
          next={() =>
            dispatch(
              setCompletedBatchFilter({
                ...currentCompletedBatchFilter,
                page: currentCompletedBatchFilter.page + 1,
              })
            )
          }
          hasMore={
            (completedBatchStatus.data?.responseContent.length || 0) >=
            currentCompletedBatchFilter.page * 10
          }
          loader={<h4>Cargando...</h4>}
          endMessage={
            <p style={{textAlign: 'center'}}>
              <b>¡Llegó al final de la lista!</b>
            </p>
          }
        >
          {completedBatchStatus.data?.responseContent.map((item: BatchCompleted) => (
            <BatchCard
              key={item.id}
              title={item.title}
              subtitle={'Ref: ' + item.reference}
              icon={true}
              columns={[
                {
                  title: 'Pagos realizados',
                  className: '',
                  value: (
                    <>
                      <span className='text-success'>{item.validRecords}</span>
                      <span className='text-gray'> / {item.totalRecords}</span>
                    </>
                  ),
                },
                {
                  title: 'Fecha de creación',
                  className: '',
                  value: <span className='text-primary-dark'>{item.creationDate}</span>,
                },
                {
                  title: 'Fecha de ejecución',
                  className: '',
                  value: <span className='text-primary-dark'>{item.resolutionDate}</span>,
                },
                {
                  title: 'Pago programado',
                  className: 'text-xxl-end',
                  value: <span className='text-primary-dark'>{item.amount}</span>,
                },
                {
                  title: 'Pago realizado',
                  className: 'text-xxl-end',
                  value: <span className='text-success'>{item.paidAmount}</span>,
                },
                {
                  title: 'Acciones',
                  className: 'flex-nowrap text-end',
                  value: (
                    <>
                      <a
                        className='btn btn-md btn-icon btn-light-primary btn-circle btn-active-primary me-3'
                        onClick={() => {
                          downloadBatch({info: infoState, requestContent: {batchid: item.id}})
                        }}
                      >
                        <KTSVG path='/media/soyfri-media/download.svg' className='svg-icon-2' />
                      </a>
                      <Link
                        className='btn btn-md btn-icon btn-light-primary btn-circle btn-active-primary'
                        to={`/history/${item.id}/detail`}
                      >
                        <KTSVG path='/media/soyfri-media/arrow-right-short.svg' />
                      </Link>
                    </>
                  ),
                },
              ]}
            />
          ))}
        </InfiniteScroll>
      ) : (
        <div className='d-flex flex-column text-center'>
          <KTSVG
            path='/media/soyfri-media/Empty_state.svg'
            svgClassName='w-100 h-100 w-sm-50 h-sm-50 w-lg-25 h-lg-25'
          />

          <span className='fw-semibold text-primary-dark fs-2qx'>
            No se encontraron resultados.
          </span>
          <div className='text-primary-dark fs-4 w-50 mx-auto'>
            Lamentablemente, no hay ningún resultado que coincida con los filtros que has aplicado.
            Te sugerimos revisar los filtros y ajustarlos para ampliar la búsqueda.
          </div>
        </div>
      )}
    </>
  )
}

export {HistoryListCard}
